export default __webpack_public_path__ + "static/media/hilda.986a91a4.png";